import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { EStorageKeys } from '../../shared/enums/storage-keys.enum';
import { StorageService } from '../../shared/services/storage.service';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const storageService = inject(StorageService);

  // Token direkt synchron aus dem Storage holen
  const token = storageService.getItem(EStorageKeys.ACCESS_TOKEN);

  // Prüfen, ob es sich um eine MapTiler-Anfrage handelt
  const isMapTilerRequest = req.url.includes('api.maptiler.com');

  // Request mit Token anreichern, falls vorhanden und es keine MapTiler-Anfrage ist
  let authReq = req;
  if (token && !isMapTilerRequest) {
    authReq = req.clone({
      setHeaders: {
        Authorization: 'Bearer ' + token,
      },
    });
  }

  // Request weiterleiten und Fehler abfangen
  return next(authReq).pipe(
    catchError((error) => {

      if (error.status === 401) {
        // Token entfernen
        storageService.removeItem(EStorageKeys.ACCESS_TOKEN);

        // Datenbank leeren
        storageService.clear();
        router.navigate(['/login']);
      }
      return throwError(() => error);
    }),
  );
};
